import { Dayjs } from "dayjs";
import { AirportType } from "src/Modules/Flights/constants";
import { buildTrie, PathTree } from "src/utility/tree";

const JOURNEY_PROPS = {
  imgUrl: { path: ["segments", 0, "flights", 0, "airlineImage"] },
  airline: { path: ["segments", 0, "flights", 0, "airline"] },
  seatsAvailable: { path: ["segments", 0, "flights", 0, "seatsAvailable"] },
  priceObject: { path: ["price"]},
  points: { path: ["points"], default: 0 },
  segments: { path: ["segments"], default: [] },
  isRefundable:{path:["isRefundable"], default:false},
  isLcc:{path:["isLcc"],default:false},
  miniRules:{path:["miniRules"],default:[]},
} satisfies PathTree;

const DERIVED_JOURNEY_TREE = buildTrie(JOURNEY_PROPS);

type PointItem = {
  type:"point"
  time:Dayjs,
  position:AirportType,
  positionType:"start"|"end",
  dayOffset?:number;
}


export type {PointItem};


export { DERIVED_JOURNEY_TREE };
